import commentLoad from '../libraries/comment-load'
import commentPost from '../libraries/comment-post'

export default {

  list() {
    document.addEventListener('DOMContentLoaded', () => {
      Array.from(document.getElementsByName('search')).forEach(el => {
        el.addEventListener('click', (e) => {
          const form_element = el.parentNode.parentNode
          form_element.action = '/manage/change_requests'
          form_element.submit()
        })
      })

    }, false)
  },

  show() {
    document.addEventListener('DOMContentLoaded', () => {
      const store_id = document.getElementById('store_id').value
      let token = ''

      Array.from(document.getElementsByTagName('meta')).forEach(meta => {
        if (meta.name != 'csrf-token') return
        token = meta.content
      })

      Array.from(document.getElementsByClassName("comment-input")).forEach(el => {
        el.readOnly = false
      })

      commentLoad(store_id, token, 30)
      commentPost(store_id, token)

      Array.from(document.getElementsByClassName('comment-reload')).forEach(el => {
        el.addEventListener('click', (e) => {
          commentLoad(store_id, token, 30)
        })
      })

      Array.from(document.getElementsByClassName('reload')).forEach(el => {
        el.addEventListener('click', (e) => {
          location.reload() 
        })
      })

      const transcript_store_id = document.getElementById('transcript_store_id').value
      const store_view_list = document.getElementsByClassName('store_view')
      const transcript_store_view_list = document.getElementsByClassName('transcript_store_view')
      const store_id_view_list = document.getElementsByClassName('store_id_view')
      Array.from(document.getElementsByClassName('is-transcript')).forEach(el => {
        el.addEventListener('change', (e) => {
          if (e.target.value == "1" ) {
            for (var i = 0; i < store_view_list.length; i++) {
              store_view_list[i].classList.add('no-show')
              transcript_store_view_list[i].classList.remove('no-show')
            }
            for (var i = 0; i < store_id_view_list.length; i++) {
              store_id_view_list[i].value = transcript_store_id
            }
          } else {
            for (var i = 0; i < store_view_list.length; i++) {
              transcript_store_view_list[i].classList.add('no-show')
              store_view_list[i].classList.remove('no-show')
            }
            for (var i = 0; i < store_id_view_list.length; i++) {
              store_id_view_list[i].value = store_id
            }
          }
        })
      })
    })
  }

}
